<script>
  import Item from '@components/global-search/item.svelte'
  
  let { list, itemKey = (_item, idx) => idx } = $props()
</script>

<svelte:window onkeydown={list.onkeydown} />

<!-- The left column housing the list of results, with scrollable overflow, should be 40% of the width -->
<div class="min-h-0 overflow-y-auto rounded-b-lg p-3 flex-1">

  <!-- The results header -->
  <h6 class="text-xs text-stone-500 mb-2 ml-2">Résultats</h6>
  
  <!-- If we have results, show them -->
  {#each list.items as item, idx (itemKey(item, idx))}
    <Item {item} index={idx} {list} />
  {/each}
</div>